import * as Linking from 'expo-linking';

import type { AppLinkingOptions } from './AppNavigation.props';

export const appNavigationLinking: AppLinkingOptions = {
  prefixes: [
    Linking.createURL('/', { scheme: 'sweetgreen-order' }),
    'https://*.sweetgreen.com',
    'https://sweetgreen.com',
    'order://',
  ],
  config: {
    initialRouteName: 'MainTabs',
    screens: {
      MainTabs: {
        screens: {
          HomeTab: {
            screens: {
              Home: { path: '', exact: true },
            },
          },
          MenuTab: {
            screens: {
              Locations: { path: 'locations', exact: true },

              // A "placeholder" route that will always redirect users to the
              // menu or delivery menu route if the location slug or address ID
              // is available, or to the location selection route if it is not.
              MenuWithoutSlug: { path: 'menu', exact: true },

              Menu: { path: ':restaurantSlug/menu', exact: true },
              DeliveryMenu: {
                path: 'delivery/:addressId/menu',
                exact: true,
              },
              MenuCollection: {
                path: ':restaurantSlug/collections/:menuCollectionId',
                exact: true,
              },
              DeliveryMenuCollection: {
                path: 'delivery/:addressId/collections/:menuCollectionId',
                exact: true,
              },
            },
          },
          LoyaltyTab: {
            screens: {
              SweetpassHome: { path: 'sweetpass', exact: true },
              Challenges: { path: 'challenges', exact: true },
            },
          },
          AccountTab: {
            initialRouteName: 'AccountMenu',
            screens: {
              AccountMenu: { path: 'account/menu', exact: true },
              Profile: { path: 'account/info', exact: true },
              SweetpassMembership: {
                path: 'account/sweetpass/membership',
                exact: true,
              },
              PaymentCredit: { path: 'account/payment-credit', exact: true },
              Addresses: { path: 'account/addresses', exact: true },
              Orders: { path: 'account/orders', exact: true },
              Favorites: { path: 'account/favorites', exact: true },
              ReferFriend: { path: 'account/refer-friend', exact: true },
              AccountDietaryRestrictions: {
                path: 'account/dietary-restrictions',
                exact: true,
              },
            },
          },
        },
      },
      Modal: {
        screens: {
          ProductDetails: {
            path: ':restaurantSlug/:productSlug',
            exact: true,
          },
          EditProductDetails: {
            path: ':restaurantSlug/:productSlug/edit/:lineItemId',
            exact: true,
          },
          DeliveryProductDetails: {
            path: 'delivery/:addressId/:productSlug',
            exact: true,
          },
          DeliveryEditProductDetails: {
            path: 'delivery/:addressId/:productSlug/edit/:lineItemId',
            exact: true,
          },

          DeliveryOrderInFlight: {},

          ReorderConfirmLocation: {},
          ReorderChangeLocation: {},
          ReorderConflictReview: {},
          ReorderActiveBagWarning: {},

          PersonalData: { path: 'ca-data-requests', exact: true },
          PersonalDataDetails: {},

          Bag: {},
          Checkout: { path: 'checkout', exact: true },

          OrderStatus: { path: 'order-status/:orderId', exact: true },

          ScanToPay: { path: 'scan-to-pay', exact: true },
          Payments: {
            path: 'payment/list',
            exact: true,
          },
          PaymentCredit: {
            path: 'payment/select',
            exact: true,
          },
          CreditAdd: {
            path: 'credit/add',
            exact: true,
          },
          CreditScan: {
            path: 'credit/scan',
            exact: true,
          },
          CreditDetails: {
            path: 'credit',
            exact: true,
          },

          DietaryRestrictions: {
            path: 'dietary-restrictions',
            exact: true,
          },
          RateOrder: { path: 'feedback/:orderId', exact: true },
          ShareLineItem: { path: 'share/:lineItemSlug', exact: true },

          SweetpassBenefits: { path: 'sweetpass/benefits', exact: true },
          SweetpassUpgrade: { path: 'sweetpass/upgrade', exact: true },
          SweetpassCheckout: { path: 'sweetpass/checkout', exact: true },
          SweetpassPaymentMethodEdit: {
            path: 'sweetpass/payment/:paymentMethodId',
            exact: true,
          },
          SweetpassPaymentMethodAdd: {
            path: 'sweetpass/payment/add',
            exact: true,
          },
          SweetpassBillingHistory: {
            path: 'sweetpass/membership/billing-history',
            exact: true,
          },

          OrderProductConfirmProduct: {
            path: '/order-product/:productSlug',
            exact: true,
          },
          OrderProductConfirmLocation: {
            path: '/order-product/:productSlug/confirm-location',
            exact: true,
          },
          OrderProductSearchLocation: {
            path: '/order-product/:productSlug/search-location',
            exact: true,
          },
        },
      },
      Auth: {
        screens: {
          Login: { path: 'login', exact: true },
          Join: { path: 'join', exact: true },
          JoinVerification: { path: 'register/verify', exact: true },
          ForgotPassword: { path: 'forgot-password', exact: true },
        },
      },
      Error: {
        screens: {
          NotFoundWithRestaurantSlug: { path: ':restaurantSlug', exact: true },
          NotFound: { path: '*' },
        },
      },
    },
  },
};
